import { notifications } from "@mantine/notifications";
import i18next from 'i18next';
import { ApiResponse } from '@/services/api-service';
import { IconCheck, IconX } from '@tabler/icons-react';

const defaultAutoClose = 3000;

export const notify = {
    smart: (response: ApiResponse<any>, operation: string) => {
        if (response.data) {
            // notify.success('Hurray!', operation + '.success');
        } else {
            notify.error('Oops!', operation + '.error');
        }
    },
    success: (title: string, message: string, autoClose: number = defaultAutoClose) => {
        notifications.show({
            title: i18next.t(title),
            message: i18next.t(message),
            radius: 'lg',
            color: 'green',
            withBorder: true,
            autoClose: autoClose,
            classNames: {
                root: '!bg-green-800 !border-green-800 w-fit',
                description: '!text-white',
                title: '!text-white !font-semibold',
                closeButton: '!text-white',
            },
        });
    },
    error: (title: string, message: string, autoClose: number = defaultAutoClose) => {
        notifications.show({
            title: i18next.t(title),
            message: i18next.t(message),
            color: 'red',
            radius: 'lg',
            withBorder: true,
            autoClose: autoClose,
            classNames: {
                root: '!bg-red-800 !border-red-800 w-fit',
                description: '!text-white',
                title: '!text-white !font-semibold',
                closeButton: '!text-white',
            },
        });
    },
};